// extracted by mini-css-extract-plugin
export var menuItem = "w_tJ d_fZ d_bz d_bD d_bP d_bf";
export var menuItemSub = "w_tK d_Z d_bz d_bP";
export var menuMainLink = "w_tL d_f0 d_dB";
export var menuLink = "w_tM d_f0 d_dB";
export var icon = "w_p9 d_bC d_bP";
export var divider = "w_tN d_bC d_bP";
export var sublinks = "w_tP";
export var link = "w_mC";
export var Link = "w_rX s_rX s_q8 s_rt";